import { BRANDED_FARE_FEATURES_CONFIG } from "./constants.js";
import memoize from "lodash/memoize";
const FARE_RULE_FEATURE_NAMES = ["CHANGEABLE_TICKET", "REFUNDABLE_TICKET"];
export const getFeatureConfigsByName = memoize(() => {
    const featureConfigsByName = {};
    for (const config of BRANDED_FARE_FEATURES_CONFIG) {
        featureConfigsByName[config.name] = config;
    }
    return featureConfigsByName;
});
export const getLabelCopy = (featureName, availability, useAltCopy) => {
    const config = getFeatureConfigsByName()[featureName];
    if (!config)
        return undefined;
    switch (availability) {
        case "SELLABLE":
            return (useAltCopy && config.sellableFeatureCopyAlt) || config.sellableFeatureCopy;
        case "NOT_INCLUDED":
            return (useAltCopy && config.nonIncludedFeatureCopyAlt) || config.nonIncludedFeatureCopy;
        default:
            return (useAltCopy && config.includedFeatureCopyAlt) || config.includedFeatureCopy;
    }
};
export const isFlexibleFeature = (name) => {
    return [
        "CHANGEABLE_TICKET",
        "CHANGE_ANYTIME",
        "CHANGE_FEE",
        "CHANGE_AFTER_DEPARTURE",
        "CHANGE_BEFORE_DEPARTURE",
        "SAME_DAY_CHANGE",
        "SAME_DAY_AS_ORIGINAL_FLT"
    ].includes(name);
};
export const isCancellableFeature = (name) => {
    return ["REFUNDABLE_TICKET", "REFUND_AFTER_DEPARTURE", "REFUND_BEFORE_DEPARTURE"].includes(name);
};
export const removeFeaturesWithNameAndAvailability = (features, exclusionList) => features.filter((feature) => !exclusionList.some((f) => isEqualToFeature(f, feature)));
export const filterFeaturesByPriority = (features, priorityList) => {
    const topPriority = priorityList.findIndex((f) => features.some((feature) => isEqualToFeature(f, feature)));
    if (topPriority === -1)
        return features;
    return features.filter((feature) => {
        const priority = priorityList.findIndex((f) => isEqualToFeature(feature, f));
        return priority === -1 || priority === topPriority;
    });
};
export const mergeFeatures = (features, source, target) => {
    const shouldMerge = source.every((feature) => features.some((f) => isEqualToFeature(f, feature)));
    if (!shouldMerge)
        return features;
    return [...removeFeaturesWithNameAndAvailability(features, source), target];
};
const isEqualToFeature = (a, b) => a.featureName === b.featureName && a.availability === b.availability;
export const filterByAvailability = (features, availability) => features.filter((feature) => feature.availability === availability);
export const filterFareRuleFeatures = (features, isFlightDetails) => isFlightDetails
    ? features
    : features.filter(({ featureName, code }) => !FARE_RULE_FEATURE_NAMES.includes(featureName) || code);
